export const emptyDataPlaceholder = '----';
